import { lazy, useEffect } from 'react'
import { useConfigurationContext, useSessionTimer } from '@nv/contexts'
import { useKeycloakSessionTime, useKeycloakTokenRefresh } from '@nv/hooks'
import LogoutTimer from '../logout_timer/LogoutTimer'
import useNVModal from '../modal_master/nv_modal/useNVModal'
const ExtendSession = lazy(() => import('@nv/lazy-loadable/lib/modals/ExtendSession'))

export function SessionTimer({ disableSessionExtension = false }: any) {
  const { maxSessionTimeMinsAdmin, maxSessionTimeMinsVoter } = useConfigurationContext()
  const maxTime = window.location.pathname.includes('admin') ? maxSessionTimeMinsAdmin : maxSessionTimeMinsVoter
  useKeycloakTokenRefresh()
  const adminPage = window.location.pathname?.startsWith('/admin') ? true : false
  const { sessionEnding, doExtendSession, endSession } = useSessionTimer()
  const { NVModal, openModal } = useNVModal()

  const sessionTimeRemaining = useKeycloakSessionTime(maxTime)

  useEffect(() => {
    if (sessionEnding) openModal()
  }, [sessionEnding])

  return (
    <>
      {adminPage && !disableSessionExtension && (
        <NVModal>
          <ExtendSession endSession={endSession} doExtendSession={doExtendSession} sessionTimeRemaining={sessionTimeRemaining} />
        </NVModal>
      )}
      <LogoutTimer sessionTimeRemaining={sessionTimeRemaining} />
    </>
  )
}
